// extracted by mini-css-extract-plugin
export default {"SummaryFooter":"RpTIT4WWwG3mFuJwTOj0","Total":"E98QTVufBVQuq3J9BOjt","TotalPoints":"JC74jzs_WavNEUc7041d","TotalPrice":"bKQJ0K9CLdGzznzWg2Xa"};